/*
 * Product Scripts
 */

//Shuffle
(function($){ 
  $.fn.shuffle = function(){
    var allElems = this.get(),
        getRandom = function(max){
          return Math.floor(Math.random() * max);
        },
        shuffled = $.map(allElems, function(){
          var random = getRandom(allElems.length),
              randEl = $(allElems[random]).clone(true)[0];
          allElems.splice(random, 1);
          return randEl;
        });
    this.each(function(i){
      $(this).replaceWith($(shuffled[i]));
    });
    return $(shuffled);
  }; 
})(jQuery);
//Related
$('#related .product').shuffle();
$('#related .product:nth-child(4)').nextAll().remove();  

//Cambio del titulo de Care Instructions para Gift Card

document.addEventListener("DOMContentLoaded", function () {
  
    // Confirmar que es la página del producto específico
    if (window.location.pathname.includes('/products/e-gift-card')) {

        const headers = document.querySelectorAll('h3');

        headers.forEach(h3 => {
            if (h3.textContent.includes("Care Instructions")) {
                h3.textContent = "Instructions";
            }
        });
    }
});